module.exports = __webpack_public_path__ + "static/media/bentonite.92068630.jpg";